import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://api.soopsystem.com/api",

    // "http://16.170.203.32:3002/api",
    // https://api.soopsystem.com/api
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) =>
        Promise.reject(
            (error.response && error.response.data) || "some thing went wrong"
        )
);
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
